import React from 'react';
import { User } from '../shared/api/apiClient';

interface AvatarProps {
  user: User | null;
  width?: number;
  height?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ 
  user, 
  width = 48, 
  height = 48, 
  className = '' 
}) => {
  const getInitials = () => {
    if (user?.full_name) {
      const names = user.full_name.split(' ');
      if (names.length >= 2) {
        return `${names[0][0]}${names[1][0]}`.toUpperCase();
      }
      return names[0][0].toUpperCase();
    }
    if (user?.username) {
      return user.username[0].toUpperCase();
    }
    if (user?.email) {
      return user.email[0].toUpperCase();
    }
    return 'U';
  };

  const getAvatarUrl = () => {
    // For now, we'll use the generated avatar URL
    return `https://ui-avatars.com/api/?name=${getInitials()}&background=f59e0b&color=ffffff&size=${width}`;
  };

  return (
    <div 
      className={`rounded-full bg-brand-500 flex items-center justify-center text-white font-medium ${className}`}
      style={{ width, height }}
    >
      <span className="text-sm font-semibold">
        {getInitials()}
      </span>
    </div>
  );
};

export default Avatar;
